import Slider from "../../components/Slider/Slider";
import { Images } from "../../assets/assets";
import React, { useCallback, useEffect, useState } from "react";
import { useCart } from "../../components/CartContext/CartContext";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { ProductService } from "../../APIs";

import addressServiceInstance, { Address } from "../../APIs/address";
import { WmsOrderDataContext } from "../../@types/productInfo";
import cartServiceInstance from "../../APIs/cartItems";

const ThankYou = ({
  title,
  textBackground,
  backgroundImg,
  isHalf,
  subTitle,
}: {
  title?: string;
  subTitle?: string;
  textBackground?: string;
  isHalf?: boolean;
  backgroundImg?: string;
}) => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const { cart,  orderReference,  getItemFromDB } = useCart();
  const [address, setAddress] = useState<Address | null>(null);


  const { user } = useAuth();

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  const getUserAddress = useCallback(
    async (userId: number) => {
      try {
        const response = await addressServiceInstance.getPrimaryAddressByUserId(
          userId
        );

        if (response.data) {
          setAddress(response.data || null);
        } else {
          console.error(response.error);
        }
      } catch (err) {
        console.error("Failed to fetch user address:", err);
        setAddress(null);
      }
    },
    [setAddress]
  );

  useEffect(() => {
    if (user?.id && address === null) {
      getUserAddress(user.id);
    }
  }, [user?.id, getUserAddress, address]);

  const updateOrderStatus = useCallback(async () => {
    try {
      if (orderReference && address && cart.length > 0 && user) {
        for (const item of cart) {
          if (!item.sku) {
            console.error(`Item ${item.id} has no SKU, skipping`);
            continue;
          }

          const now = new Date();
          const itemPrinciple = item.principle || "";
          const wmsOrderData: WmsOrderDataContext = {
            OrderNumber: orderReference,
            orderDate: `${now.getFullYear()}-${String(
              now.getMonth() + 1
            ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`,
            customerName: user.firstName || "",
            companyName: "Nucleus",
            contactNumber: user.phone_number || "string",
            addressLine1: address.address_1 || "",
            addressLine2: "",
            suburb: address.suburb || "",
            city: address.city || "",
            postalCode: address.postal_code || "3453",
            itemCode: item.sku,
            warehouse: "Sodastream Head Office",
            description: item.name || "Product",
            principle: itemPrinciple,
            quantity: item.item_quantity || 0,
            status: "Fulfill",
          };
  
          const {  error } = await ProductService.processWmsOrder(wmsOrderData);
          if (error) {
            console.error(
              `Failed to update order status for item ${item.sku}:`,
              error
            );
          } else {
          }
        }

        const res = await cartServiceInstance.removeFromCart(orderReference);

        if (res.data) {
          // setCart([])
          getItemFromDB(orderReference);

          // clearCart();
        } else {
          console.log("An error occurred:", res.error);
        }
      }
    } catch (error) {
      console.error("Error updating order status:", error);
    } finally {
     
    }
  }, [orderReference, address, cart, user, getItemFromDB]);

  useEffect(() => {
    if (user?.id && address) {
      updateOrderStatus();
    }
  }, [user?.id, getUserAddress, address, updateOrderStatus]);

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);
    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, []);

  return (
    <>
      <div
        className={`${
          isHalf ? "md:h-[60vh]" : "md:h-[79vh]"
        } relative overflow-hidden`}>
        <div className="  flex relative w-full ">
          {screenSize.width < 1060 && <Navbar />}
        </div>

        <Slider
          images={[backgroundImg ? backgroundImg : Images.StoreLocatorBg]}
        />
        <div className="overflow-hidden whitespace-nowrap">
          <p
            style={{
              marginTop: screenSize.width > 1060 ? "1%" : "-45%",
            }}
            className=" w-[90px] absolute top-45 md:top-1/4 left-10 text-left
             font-black text-[30px] md:text-[200px]
         md:leading-[95px] tracking-normal text-[#75A7AD] 
         uppercase opacity-50 font-dm-sans z-0 ">
            Your Cart
          </p>
        </div>

        <div className="absolute  top-40 md:top-0 md:left-0 w-full">
          {screenSize.width > 1060 && <Navbar />}

          <div className="md:mt-[80px] ml-[10%] flex flex-col ">
            <p
              style={{ marginTop: "10%" }}
              className="text-left text-[15px] md:text-[20px] tracking-normal
         text-white opacity-100 font-semibold "></p>
          </div>
        </div>
      </div>

      <section className="relative w-full mt-[-26%] mb-[20px]  ">
        <div className="md:relative gap-10  flex flex-col items-center justify-center w-full">
          <div className=" relative w-[72%]  text-[#005D6E] mt-[-40px] mb-[35px]">
            <h1
              className="text-[45px]  tracking-normal
           text-white opacity-100 font-bold ">
              Your Cart
            </h1>
          </div>
          <div className="bg-white rounded-xl border-[0.5px] border-[#75A7AD] relative w-[85%] md:w-[75%] opacity-80 px-10 py-20 text-[#005D6E]">
            <div className="bg-white ">
              <div className="w-full">
                <h1
                  className="text-center 
        text-[#005D6E] block text-[29px] font-semibold  leading-[38.4px]">
                  Thank you for your purchase!
                </h1>

                <p
                  className="text-center 
        text-[#005D6E] block  text-[18px] font-semibold  leading-[38.4px]">
                  Thank you for choosing to shop with us! We are thrilled to
                  have you as a part of our SodaStream family. Your order has
                  been successfully processed and is now being prepared for
                  delivery. You will receive a confirmation email shortly with
                  the details of your purchase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ThankYou;
